import { render, staticRenderFns } from "./SchoolListToolbar.vue?vue&type=template&id=e8769ae2"
import script from "./SchoolListToolbar.vue?vue&type=script&lang=js"
export * from "./SchoolListToolbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports